import { RunGroupFormValues } from "@features/run/RunGroupDialog/RunGroupForm"
import { useEffect } from "react"
import { useFormContext } from "react-hook-form"

type LinkedGraphValidFieldProps = {
  isValidating: boolean
  haveErrors: boolean
}

export const LinkedGraphValidField = ({ isValidating, haveErrors }: LinkedGraphValidFieldProps) => {
  const { setError, clearErrors, register } = useFormContext<RunGroupFormValues>()
  const linkedGraphValidField = register("linked_graph_valid", {
    setValueAs: (value) => {
      if (value === "" || value === undefined || value === null) return undefined
      return value === true || value === "true"
    },
  })

  useEffect(() => {
    if (isValidating || haveErrors) {
      setError("linked_graph_valid", { type: "manual" })
    } else {
      clearErrors("linked_graph_valid")
    }
  }, [isValidating, haveErrors, setError, clearErrors])

  useEffect(() => {
    return () => clearErrors("linked_graph_valid")
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only clear on unmount
  }, [])

  return <input type="hidden" value="true" {...linkedGraphValidField} />
}
